/**
 * Global Functionality
 * The logic in this is intended to ONLY contain any functionality
 * that is required on every page load.
 *
 * NOTE: Please do not include any page-specific logic here.
 **/

import Logger from "../lib/logger";
import ThemeHeader from "./partials/ThemeHeader";
import jQuery from "jquery";

window.jQuery = jQuery;

export default function () {
	const NAME = 'Global';
	Logger.info(`${NAME} > loading`);

	// Vars
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

	const themeHeaderDom = document.querySelector(`[data-theme-header]`);

	// Logic
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

	/**
	 * init --- Initialization block
	 */
	function init() {
		Logger.info(`${NAME} > init`);
		initThemeHeader();
	}

	/**
	 * initThemeHeader - Initialize the theme header
	 */
	function initThemeHeader() {
		Logger.info(`${NAME} > initThemeHeader`);

		if (themeHeaderDom) {
			const themeHeader = new ThemeHeader(themeHeaderDom);
			themeHeader.init();
			themeHeader.on(`ThemeHeader:search_toggled`, (isOpen) => {
				if (isOpen) {
					window.scrollTo(0, 0);
					stopBodyScrolling(true);
				} else {
					stopBodyScrolling(false);
				}
			});
		}
	}

	/**
	 * Stop the body from scrolling
	 */
	function stopBodyScrolling(bool) {
		Logger.info(`${NAME} > stopBodyScrolling`);
		if (bool === true) {
			document.body.style.overflow = 'hidden'; document.getElementsByTagName('html')[0].style.overflow = `hidden`;
		} else {
			document.body.style.overflow = 'auto'; document.getElementsByTagName('html')[0].style.overflow = `auto`;
		}
	}


	// Do not edit below this line...
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
	Logger.info(`${NAME} > loaded`);

	init();
}
